<template>
  <v-btn v-blur v-bind:class="{ pulse }" rounded x-large height="56" color="primary" v-on="$listeners">RSVP</v-btn>
</template>

<script>
export default {
  name: 'rsvp-btn',
  props: [ 'pulse' ]
}
</script>
